export { default } from '../de/faq-coloring-options';



// WEBPACK FOOTER //
// ./src/components/async/defaq-coloring-options.js